import { createContext } from 'react';
export const SeoContext = createContext(null);
